export default __webpack_public_path__ + "static/media/jurnal.c487da9d.svg";